"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _underscore = _interopRequireDefault(require("underscore"));

var _backbone = _interopRequireDefault(require("backbone"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopupView = _backbone.default.View.extend({
  modalOptions: {
    keyboard: false,
    backdrop: 'static'
  },
  initialize: function initialize() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var thisView = this;
    this.$el.addClass('modal');
    this.disableClickOutside && this.$el.attr('data-backdrop', 'static').attr('data-keyboard', 'false');
    this.parent = options.parent ? options.parent : 'body';
    this.$el.on('hidden', function () {
      thisView.remove();
    });
    this.$el.on('shown', function () {
      thisView.viewRendered();
    });
  },
  show: function show() {
    this.render();
    var element = this.$el;
    var haveElement = !!element;

    if (haveElement) {
      var parent = this.parent;

      if (parent) {
        var isWidget = (0, _jquery.default)('body').hasClass('widget');

        if (this.elementId && isWidget) {
          var parentHeight = (0, _jquery.default)(parent).height();
          var offsetHeight = parentHeight > 200 ? parentHeight - 200 : 200;
          var parentWidth = (0, _jquery.default)(parent).width();
          var offsetWidth = parentWidth > 0 ? parentWidth / 2 : 200;
          var minWidth = parentWidth < 600 ? "".concat(parentWidth, "px") : '650px';
          var requiredHeight = this.calculatePopUpMessageInWidgetHeight();
          this.$el.css({
            position: 'absolute',
            overflow: 'hidden',
            top: "".concat(offsetHeight, "px"),
            left: "".concat(offsetWidth, "px"),
            transform: 'translate(-50%, -50%)',
            'min-width': minWidth,
            'min-height': requiredHeight < 300 ? '300px' : "".concat(requiredHeight, "px")
          });
        }

        element.appendTo(parent);
        element.addClass('modal fade').modal(this.modalOptions);
      }
    }
  },
  calculatePopUpMessageInWidgetHeight: function calculatePopUpMessageInWidgetHeight() {
    var successMessageHolder = (0, _jquery.default)('.js-submit-success');
    var messageText = successMessageHolder && successMessageHolder[0];
    var messageHTML = messageText && messageText.innerText;
    messageHTML && successMessageHolder.html(messageHTML);
    return successMessageHolder.height();
  },
  viewRendered: function viewRendered() {// Override this in subclass (called after view was rendered)
  },
  hide: function hide() {
    this.$el.modal('hide');
  },
  destroy: function destroy() {
    this.$el.off('hidden');
    this.$el.off('shown');
  },
  remove: function remove() {
    this.destroy();

    _backbone.default.View.prototype.remove.call(this);
  }
});

PopupView.prototype.mixin = {
  popup: PopupView.prototype.initialize,
  popupShow: PopupView.prototype.show,
  popupHide: PopupView.prototype.hide,
  popupDestroy: PopupView.prototype.destroy
};
var _default = PopupView;
exports.default = _default;